import React, { useRef } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { TabsCoursesProps } from ".";
import PracticeByCoursesHandPlayTab from "features/courses/components/PracticeByCoursesHandPlayTab/PracticeByCoursesHandPlayTab";
import PracticeByCoursesTricksTab from "features/courses/components/PracticeByCoursesTricksTab/PracticeByCoursesTricksTab";
import PracticeByTechniqueTab from "features/courses/components/PracticeByTechniqueTab";
import MiniBridgeTab from "features/courses/components/MiniBridgeTab";
import SummariesTab from "screens/BySummary/components/SummariesTab";
import ModalExpiredGame from "../ModalExpiredGame/ModalExpiredGame";
import { useTypedDispatch, useTypedSelector } from "store";
import { setSimpleField } from "store/users/slice";

const TabsCoursesDesktop = ({
  RenderComponent,
  dataAllCourses,
  onSelect,
  searchRes,
  onPressItem,
  onPressTricksPlay,
  onPressHandPlay,
  onPressDefLeadPlay,
  onPressDeffensePlay,
  onPressMiniBridge,
  search,
  listTitle,
  keyTab,
  listKeys,
  type,
  isExpired,
  onExpiredClose
}: TabsCoursesProps) => {
  const isDeffense = useRef(false);
  const isDefLead = useRef(false);
  const { blockMixCourses } = useTypedSelector((store) => store.user);
  const dispatch = useTypedDispatch();

  const isLastTabActive = listKeys && keyTab === listKeys[listKeys.length - 1];

  return (
    <div className={`tab-courses-desktop ${isLastTabActive ? "last-tab-active" : ""}`}>
      <Tabs defaultActiveKey="home" className="mb-3" onSelect={onSelect} activeKey={keyTab}>
        {listKeys &&
          listKeys.map((val: any, index) => {
            let Component = RenderComponent || null;
            let onHandlePress = onPressItem;
            switch (val) {
              case "handPlay":
                Component = PracticeByCoursesHandPlayTab;
                onHandlePress = onPressHandPlay;
                break;
              case "tricks":
                Component = PracticeByCoursesTricksTab;
                onHandlePress = onPressTricksPlay;
                break;
              case "practice":
                Component = PracticeByTechniqueTab;
                onHandlePress = undefined;
                break;
              case "defLead":
                Component = PracticeByCoursesTricksTab;
                onHandlePress = onPressDefLeadPlay;
                isDefLead.current = true;
                break;
              case "deffense":
                Component = PracticeByCoursesHandPlayTab;
                onHandlePress = onPressDeffensePlay;
                isDeffense.current = true;
                break;
              case "summary":
                Component = SummariesTab;
                onHandlePress = undefined;
                break;
              case "miniBridge":
                Component = MiniBridgeTab;
                onHandlePress = onPressMiniBridge;
                break;
            }
            return (
              <Tab eventKey={val} title={listTitle[val]} key={val}>
                {!!Component && (
                  <Component
                    isFirstTab={index === 0 ? true : false}
                    data={dataAllCourses[val]}
                    valKey={val}
                    onPressItem={onHandlePress}
                    searchData={searchRes}
                    searchText={search}
                    search={search}
                    isDefLead={isDefLead.current}
                    isDeffense={isDeffense.current}
                    type={type === "handPlay_tricks" ? "hand_play" : "deffense"}
                  />
                )}
              </Tab>
            );
          })}
      </Tabs>
      <ModalExpiredGame
        visible={isExpired}
        firstTitle={type === "bidding" ? " אפשרות זו שמורה למנויים בתשלום בלבד" : ""}
        onClose={onExpiredClose}
        type="studentFolder"
      />
      <ModalExpiredGame
        visible={blockMixCourses}
        onClose={() => {
          dispatch(
            setSimpleField({
              type: "blockMixCourses",
              value: false
            })
          );
        }}
      />
    </div>
  );
};

export default TabsCoursesDesktop;
